import {GetRefundBeneficiaryBankDataParams} from 'domain/usecases/private/refund/request/get-beneficiary-bank-data';
import {makeGetRefundBeneficiaryBankData} from 'main/factories/usecases/private/refund/request/get-beneficiary-bank-data';

export async function getBeneficiaryBankData(signal: GetRefundBeneficiaryBankDataParams) {
	const response = await makeGetRefundBeneficiaryBankData().get(signal);

	return response?.content ?? null;
}
